import { getUserDetails, setUser } from "../core/storage/localStorage";

export function updateUsage() {
  const user = getUserDetails();
  const numOfMessages = user["num_of_messages"] || 0;
  setUser({ ...user, num_of_messages: numOfMessages + 1 });
  window.dispatchEvent(new Event("storage"));
}
